import FirstEpochV2 from "./FirstEpochV2";

export default FirstEpochV2;